import type { SVGProps } from "react";

import { cn } from "@/lib/utils";

export interface ScirixLogoMarkProps extends Omit<SVGProps<SVGSVGElement>, "viewBox" | "xmlns"> {
  /**
   * Optional accessible label. Defaults to a hidden glyph (`aria-hidden`).
   */
  title?: string;
}

export function ScirixLogoMark({ className, title, ...props }: ScirixLogoMarkProps) {
  const labelled = Boolean(title);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 70 70"
      fill="currentColor"
      className={cn("scirix-logo-mark", className)}
      role={labelled ? "img" : undefined}
      aria-hidden={labelled ? undefined : true}
      focusable={false}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path d="M22.76 14H61.71V0H20.49C16.16 0 12.15 1.36 8.84 3.66Z" />
      <path d="M47.95 55.27H1.02v14h47.21c4.79 0 9.2-1.62 12.75-4.32z" />
      <path d="M20.49 40.97h27.74c3.56 0 6.51 2.62 7.05 6.03l12.46 9.26C68.79 53.75 69.37 51 69.37 48.12 69.37 36.46 59.88 26.97 48.22 26.97H20.48c-3.33 0-6.07-2.52-6.44-5.75L1.8 12.13C.65 14.69 0 17.51 0 20.49 0 31.79 9.19 40.98 20.49 40.98Z" />
    </svg>
  );
}

export default ScirixLogoMark;
